import Link from 'next/link'

import Image from 'next/legacy/image'

import type { FC } from 'react'

interface LogoMainPageLinkProps {
  href?: string
  logoAlt?: string
  logoSize?: {
    width: number
    height: number
  }
  logoSrc?: string
}

export const LogoMainPageLink: FC<LogoMainPageLinkProps> = ({
  href = '/',
  logoSrc = '/logo.svg',
  logoAlt = 'logo alt text',
  logoSize = {
    width: 140,
    height: 49,
  },
}) => {
  return (
    <Link
      href={href}
      className="min-w-auto md:min-w-35"
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
      }}
    >
      <Image src={logoSrc} alt={logoAlt} priority {...logoSize} />
    </Link>
  )
}
